import { Paper, Typography, Avatar, Box } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';

type Props = {
    onClick: () => void;
};

export default function CreatePostBar({ onClick }: Props) {
  return (
    <Paper 
        variant="outlined" 
        sx={{ 
            p: 2, 
            borderRadius: 3, 
            mb: 3, 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2,
            cursor: 'pointer',
            transition: 'all 0.2s',
            '&:hover': {
                borderColor: 'primary.main',
                boxShadow: 2,
                transform: 'translateY(-2px)'
            }
        }}
        onClick={onClick}
    >
      <Avatar sx={{ width: 32, height: 32, bgcolor: 'grey.300' }} />
      <Box sx={{ flexGrow: 1, bgcolor: 'action.hover', p: 1.5, borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body2" color="text.secondary">
            What's on your mind? Share with the community...
          </Typography>
          <EditIcon sx={{ color: 'text.disabled', fontSize: 20 }} />
      </Box>
    </Paper>
  );
}
